import { css } from '@emotion/css'

const styles = {
  breadcrumbs: css({
    // unset max-width set on Breadcrumb component
    'li a': {
      maxWidth: 'none',
    },
  }),
}

export default styles
